import endPoints from './endpoints';
import StringUtils from '../utils/string-utils';
/**
 *
 * @author laci on 2016.12.06.
 */
export default function ($http) {
	return function promisedRequest(endPoint, params) {
		params = params || {};
		let config = {
			method: endPoints[endPoint].method || 'GET',
			url: StringUtils.resolvePlaceHolder(endPoints[endPoint].url, params.urlParameters || {}),
			params: angular.extend({}, params.query),
			data: params.body || {},
			headers: angular.extend({}, params.headers)
		};
		if (params.responseType) {
			config.responseType = params.responseType
		}
		return $http(config);
	};
};
